const types = {
    //TODO
    TODO_ADD: 'TODO_ADD',
    TODO_TICKED_TOGGLE: 'TODO_TICKED_TOGGLE'
};

export default types;